// extracted by mini-css-extract-plugin
export default {"li":"nav_logo-module___li___e71e2755","link":"nav_logo-module___link___e24d16a0","squareLogo":"nav_logo-module___squareLogo___c8eb095b"};